import { render, staticRenderFns } from "./PanelCompetitionSettingNumbers.vue?vue&type=template&id=b1ba7532&scoped=true&"
import script from "./PanelCompetitionSettingNumbers.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionSettingNumbers.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionSettingNumbers.vue?vue&type=style&index=0&id=b1ba7532&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ba7532",
  null
  
)

export default component.exports